import React, { useEffect, useState } from 'react';
import { Phone, Calendar, X, MessageCircle } from 'lucide-react';
export function FloatingMobileCTA() {
  const [isVisible, setIsVisible] = useState(true);
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible || !hasScrolled) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] pb-safe" data-id="element-140">
      <div className="relative px-2 py-3 flex gap-2" data-id="element-141">
        <button onClick={() => setIsVisible(false)} className="absolute -top-10 right-2 bg-white rounded-full p-1.5 shadow-md border border-gray-100 text-gray-500 hover:text-navy" aria-label="Close" data-id="element-142">
          <X className="w-4 h-4" data-id="element-143" />
        </button>

        <a href="tel:0418381988" className="flex-1 bg-orange text-white py-2.5 px-1 rounded-lg font-bold flex flex-col items-center justify-center gap-1 active:bg-orange-600 transition-colors text-xs" data-id="element-144">
          <Phone className="w-5 h-5" data-id="element-145" />
          Call Now
        </a>

        <a href="sms:0418381988" className="flex-1 bg-[#25D366] text-white py-2.5 px-1 rounded-lg font-bold flex flex-col items-center justify-center gap-1 active:bg-[#20bd5a] transition-colors text-xs" data-id="element-146">
          <MessageCircle className="w-5 h-5" data-id="element-147" />
          Text Us
        </a>

        <a href="#quote" className="flex-1 bg-navy text-white py-2.5 px-1 rounded-lg font-bold flex flex-col items-center justify-center gap-1 active:bg-navy-600 transition-colors text-xs" data-id="element-148">
          <Calendar className="w-5 h-5" data-id="element-149" />
          Get Quote
        </a>
      </div>
    </div>;
}